import React, { PureComponent } from 'react'

import ReactModal from 'react-modal'

ReactModal.setAppElement(document.querySelector('body'))

ReactModal.defaultStyles = {
    overlay: {
        position: 'fixed',
        display: 'flex',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    },
    content: {
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        outline: 'none'
    }
}

// console.log( 'ReactModal.defaultStyles: ', ReactModal.defaultStyles )

export default class Modal extends PureComponent {
    render() {
        return (
            <ReactModal {...this.props}>
                <div className="close-btn" onClick={this.props.onRequestClose}>
                    &times;
                </div>
                <div className="wrapper">
                    <div className="modal-body">
                        {this.props.children}
                    </div>
                </div>
            </ReactModal>
        )
    }
}